// extracted by mini-css-extract-plugin
module.exports = {"orginalStationRow":"styles__orginalStationRow___4DQ3M","deleteSuggestedEditsContainer":"styles__deleteSuggestedEditsContainer___UJrTY"};